import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ReCaptcha2Component } from 'ngx-captcha';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { Subject, switchMap } from 'rxjs';
import {
  ForGotPassword,
  Login,
  Otp,
  ResetOrChangePassword,
} from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
declare let $: any;
import * as CryptoJS from 'crypto-js';
import { EncryptionService } from 'src/app/services/encryption.service';
import { DOCUMENT } from '@angular/common';
import { NgZone } from '@angular/core';

declare let require: any;
let randomize = require('randomatic');

interface LanguageInterface {
  value: string;
  name: string;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild('usernameTempRef') usernameTempRef: any;
  @ViewChild('nodeInput') fileInput: any;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @Output() isSignUp = new EventEmitter<boolean>();
  config = { allowNumbersOnly: true, length: 4 };
  deviceInfo: DeviceInfo;
  isOpenedFromShortcut: boolean;
  isMobile: boolean = true;
  isOTP: boolean = false;
  isReset: boolean = false;
  isSubmitted = false;
  signIn: boolean = true;
  emailResponse: any;
  otpResponse: any;
  loginErrorMessage: string | null = null;
  isLockErrMsg: boolean = false;
  subject = new Subject<any>();
  otpValue: string = '';
  pwdNotMatch: boolean = false;
  sentEmail: string = '';
  loginPassword: boolean = false;
  newPassword: boolean = false;
  confPassword: boolean = false;
  password: any = CommonEnums.password;
  loginShowPwdIcon: boolean = false;
  getLoginUrl: any;
  timer: any;
  count: number = 0;
  submitOtpErrorMessage: any;
  durationMinutes: any;
  timeOver: any;
  getFaacebookLoginUrl: any;
  authGoogleCode: any = null;
  submitOTPDto: Otp = new Otp();
  loginDto: Login = new Login();
  resendtDto: ResetOrChangePassword = new ResetOrChangePassword();
  forgotPasswordDto: ForGotPassword = new ForGotPassword();
  forgotPasswordErrorMessage: any;
  showCaptcha: boolean = false;
  passwords: any = CommonEnums.password;
  passwordReset: any = CommonEnums.password;
  maxLength: number;
  minLength: number;
  disbleButton: boolean = false;
  mobileValid: boolean = false;
  emailOrMobileInput: boolean = true;
  isLoading: boolean = false;
  loginForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
    password: new FormControl(''),
  });
  forgotPwdEmailForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
  });

  resetPwdForm: FormGroup = new FormGroup({
    password: new FormControl(''),
    newPassword: new FormControl(''),
    captchaToken: new FormControl(''),
  });
  translation$ = this.translate.onLangChange.pipe(
    switchMap(({ lang }) => this.translate.getTranslation(lang))
  );
  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  salt: any;
  iv: any;
  enJsonData: any;
  passPhrase: any;
  language: any;
  screenWidth: any;
  otpText: any;
  emailId: any;
  openFrom: String;
  dropdownLanguages: LanguageInterface[] = [
    {
      value: 'ENGLISH',
      name: 'English'
    },
    {
      value: 'SPANISH',
      name: 'español'
    },
    {
      value: 'ITALIAN',
      name: 'italiano'
    }
  ]; // Array of language options
  selectedLanguage: string = 'ENGLISH';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private _service: ApiService,
    private encrypt: EncryptionService,
    private _commonService: CommonService,
    private _router: Router,
    private _toastr: ToastrService,
    private translate: TranslateService,
    private deviceDetectorService: DeviceDetectorService,
    private ngZone: NgZone

  ) {
    //this.Detectsource();
    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
    this.iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    this.salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
      CryptoJS.enc.Hex
    );
    this.passPhrase = randomize('0', 16);
    translate.get(['INTERCEPTOR']).subscribe((values) => {
      this.enJsonData = Object.keys(values).map((key) => values[key]);
    });
    translate.get(['LOGIN']).subscribe((values) => {
      this.loginJson = Object.keys(values).map((key) => values[key]);
    });
  }
  loginJson: any;
  ngAfterContentChecked() {
    if (this.loginForm.controls['captchaToken']?.value) {
      this.disbleButton = false;
      this.loginDto.captchaToken =
        this.loginForm.controls['captchaToken']?.value;
    }
  }
  currentUser: any;
  baseUrl: string;
  socialLang: any;
  ngOnInit(): void {
    const socialLang = localStorage.getItem('SocialSelectedLang');
    this.socialLang = socialLang
    localStorage.clear();
    localStorage.setItem('SocialSelectedLang', this.socialLang);
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        this.authGoogleCode = code;
      }
    });
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        switch (lang) {
          case 'es': this.selectedLanguage = 'SPANISH'; break;
          case 'it': this.selectedLanguage = 'ITALIAN'; break;
          default: this.selectedLanguage = 'ENGLISH'; break;
        }
        localStorage.setItem('SocialSelectedLang', this.selectedLanguage);
        const langCode = this._service.getLanguageMap[this.selectedLanguage] || 'en';
        localStorage.setItem('selectedLang', langCode);
      }
    });
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    this.language = localStorage.getItem('selectedLang');
    this._commonService.getSelectedLang.next('en');
    this.screenWidth = window.screen.width;
    this.Detectsource();
    this.useragent = navigator.userAgent;
    this.extractName();
    this.translate.onLangChange.subscribe(() => {

    });

    if (this.screenWidth > 576) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    const jwtToken = localStorage.getItem('jwtToken');
    if (this.currentUser && jwtToken) {
      this._router.navigateByUrl('/home');
    } else {
      this.loginFormInitialize();
      this.forgotPasswordFormInitialize();
      this.resetPasswordFormInitialize();
      this.getSocialUrl();
      let logintype = window.location.href.split('?code=');
      // this.authGoogleCode = logintype[1];
      this.baseUrl = logintype[0];
      if (this.authGoogleCode) {
        this.onLogin();
      } else {
        this.getRandaomUID();
      }
    }
    window.addEventListener('message', this.handleMessageFromFlutter, false);
    let langCode = this._service.getLanguageMap[this.selectedLanguage] || 'en';
    if (this.authGoogleCode) {
      langCode = this._service.getLanguageMap[this.socialLang] || 'en';
    } else {
      langCode = this._service.getLanguageMap[this.selectedLanguage] || 'en';
    }
    localStorage.setItem('selectedLang', langCode);
    this.translate.use(langCode);
  }

  fromBrowser: boolean;
  fromShortcut: boolean;
  platform: String;
  useragent: String;

  extractName() {
    if (this.useragent.includes('wv')) {
      this.platform = 'WebView';
    } else {
      this.platform = 'unKnown';
    }

  }

  isStandalones: boolean;
  Detectsource() {
    const UA = navigator.userAgent;

    const IOS = UA.match(/iPhone|iPad|iPod/);
    const ANDROID = UA.match(/Android/);

    const PLATFORM = IOS ? 'ios' : ANDROID ? 'android' : 'unknown';

    const standalone = window.matchMedia('(display-mode: standalone)').matches;

    const INSTALLED = !!(standalone || (IOS && !UA.match(/Safari/)));

    if (INSTALLED) {
      this.isStandalones = INSTALLED;
    }

    // const isStandalone =
    //   window.matchMedia('(display-mode: standalone)').matches ||
    //   (window.navigator as any).standalone ||
    //   document.referrer.includes('android-app://');
    // if (!('someStandaloneApi' in window)) {
    //   console.log('Running in standalone mode');
    // } else {
    //   console.log('Running in browser mode');
    // }

    // this.ngZone.runOutsideAngular(() => {
    //   const isStandaloneRunoutside =
    //     window.matchMedia('(display-mode: standalone)').matches ||
    //     (window.navigator as any).standalone;
    //   if (isStandaloneRunoutside) {
    //     console.log('Thank you for installing our app runOutsidemethod!');
    //     this.openPopup();
    //     this.openFrom = isStandaloneRunoutside ? 'Shortcut' : 'Browser';
    //     console.log(this.openFrom);
    //   }
    // });
  }

  ngAfterViewInit(): void {
    if (this.authGoogleCode && this.tempResoponse === null) {
      this.loginDto.authorizationCode = '';
    }
    this.usernameTempRef.nativeElement.focus();
    if (this.currentUser === null) {
      localStorage.clear();
      if (this.socialLang) {
        const langCode = this._service.getLanguageMap[this.socialLang] || 'en';
        localStorage.setItem('selectedLang', langCode);
        localStorage.setItem('SocialSelectedLang', this.socialLang);
      } else {
        const langCode = this._service.getLanguageMap[this.selectedLanguage] || 'en';
        localStorage.setItem('selectedLang', langCode);
        localStorage.setItem('SocialSelectedLang', this.selectedLanguage);
        this.translate.use(langCode);
      }

    }
  }
  randomUid: any;
  getRandaomUID() {
    this._service
      .getService(this._service.API_URL.getRandaomUID)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.randomUid = response.data.randomUid;
          localStorage.setItem('random', response.data.randomUid);
          this.saveAESKey();
        }
      });
  }

  openPopup() {
    $('#floatingWindowPopup').modal('show');
  }

  saveAESKey() {
    let data = {
      secretKey: this.salt,
      iv: this.iv,
      passPhrase: this.passPhrase,
    };
    this._service
      .postService(this._service.API_URL.saveAESKey, data)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          let genKey = this.encrypt.generateKey(this.salt, this.passPhrase);
          localStorage.setItem('identificationNo', JSON.stringify(genKey));
          localStorage.setItem('iv', this.iv);
        }
      });
  }
  //Form Initialize Start
  loginFormInitialize() {
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', Validators.required],
      captchaToken: [''],
    });
  }

  forgotPasswordFormInitialize() {
    this.forgotPwdEmailForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      captchaToken: ['', [Validators.required]],
    });
  }

  resetPasswordFormInitialize() {
    this.resetPwdForm = this.formBuilder.group({
      password: [
        '',
        [
          RxwebValidators.password({
            validation: {
              upperCase: true,
              lowerCase: true,
              specialCharacter: true,
            },
          }),
          RxwebValidators.minLength({ value: 8 }),
          RxwebValidators.maxLength({ value: 50 }),
        ],
      ],
      newPassword: ['', Validators.required],
    });
  }

  // Login form control for handling
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

  // Go to sign up on button click
  goToSignUp(value: boolean) {
    this.isSignUp.emit(value);
  }

  errorResponse(err: any) {
    this.subject.next(err);
  }

  validateEmailId() {
    this.loginForm.controls['userName'].addValidators([
      Validators.email,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
    ]);
    return this.loginForm.status === 'VALID';
  }

  checkNumber(userName: string) {
    return userName.match(/^\+?[0-9]+$/) != null ? true : false;
  }

  tempResoponse: any = null;
  //  Submitting the data for login and Redirecting to Dashboard
  isSentOtp: boolean = false;
  onLogin() {
    try {
      let isUserNameValid = false;
      if (this.authGoogleCode) {
        this.loginDto.authorizationCode = this.authGoogleCode;
        this.loginDto.langPref = this.socialLang;
      } else {
        // this.isLoading = true;
        this.isOTP = false;
        this.isSentOtp = true;
        this.timeOver = true;
        clearInterval(this.timer);
        if (this.durationMinutes) {
          this.isOTP = false;
        }
        //First email if regex gives false ten check mobile no validation if this is also failed then show the error message otherwise pass to login api
        let userName = this.loginForm.controls['userName'].value;
        if (userName?.includes('@')) {
          if (!this.validateEmailId()) {
            this.isLockErrMsg = false;
            this.loginErrorMessage = "LOGIN.INCORRECTEMAILPASS";
          } else {
            isUserNameValid = true;
          }
        } else {
          let firstChar = userName.charAt(0);
          if (firstChar == '+') {
            userName = userName.substring(1, userName?.length);
          }
          if (this.checkNumber(userName)) {
            isUserNameValid = true;
          } else {
            this.isLockErrMsg = false;
            this.loginErrorMessage = "LOGIN.INCORRECTEMAILPASS";
          }
        }
        this.loginDto.userName = this.loginForm.controls['userName'].value;
        this.loginDto.password = this.encrypt.encrypt(
          this.loginForm.controls['password'].value
        );
        this.loginDto.langPref = this.selectedLanguage;
      }
      if (
        (this.loginForm.controls['userName'].value !== '' &&
          this.loginForm.controls['password'].value !== '') ||
        this.authGoogleCode
      ) {
        if (isUserNameValid || this.authGoogleCode) {
          /*  */
          this._service
            .postService(this._service.API_URL.signIn, this.loginDto)
            .subscribe(
              (response: any) => {
                if (response === null) {
                  this.isLockErrMsg = false;
                  this.loginErrorMessage = "LOGIN.INCORRECTEMAILPASS";
                  setTimeout(() => {
                    this.tempResoponse = response;
                  }, 2000);
                }
                if (this.authGoogleCode) {
                  if (response.status.code === 200) {
                    const data = response.data;

                    localStorage.setItem('currentUser', JSON.stringify(data.signInResponse));
                    localStorage.setItem('jwtToken', data.jwtToken.accessToken);
                    localStorage.setItem('accessToken', data.jwtToken.accessToken);
                    localStorage.setItem('sessionId', data.signInResponse.sessionId);
                    localStorage.setItem('bannerExpiryDate', data.signInResponse.bannerExpiryDate);
                    localStorage.setItem('desktopPurchaseNowInternational', data.signInResponse.desktopPurchaseNowInternational);
                    localStorage.setItem('DesktopCompatibleVersion', data.signInResponse.desktopCompatibleVer);
                    localStorage.setItem('MobileCompatibleVersion', data.signInResponse.mobileCompatibleVer);
                    this._router.navigateByUrl('/home');
                  } else if (response.status.code === 401) {
                    this._toastr.error('', response.status.message);
                    this.count++;
                    if (this.count >= 3) {
                      this.disbleButton = true;
                      this.showCaptcha = true;
                      this.loginForm.controls['captchaToken'].addValidators(
                        Validators.required
                      );
                    }
                  } else {
                    this.isLockErrMsg = false;
                    // this._toastr.error('', response.status.message);
                    this.loginErrorMessage = response.status.message;
                    if (
                      response.status.msgCode ==
                      this.enJsonData[0]['USERNOTFOUND']
                    ) {
                      this.isLockErrMsg = false;
                      this.loginErrorMessage = response.status.message
                      setTimeout(() => {
                        window.location.href = this.baseUrl;
                      }, 7000);
                    }
                  }
                } else {
                  this.isLoading = false;
                  if (response.status.code === 200) {
                    if (response.status.msgCode === 'RESET_LINK_SENT') {
                      // stay on login screen
                      this.isOTP = false;
                      this.signIn = true;
                      this.isMobile = true;
                      this.loginErrorMessage = 'RESET_PASSWORD.PASS_RESET_LINK_SENT';
                      this.isLoading = false;
                      this.isLockErrMsg = true;
                      return;
                    }
                    if (response.status.msgCode === 'RESET_LINK_ALREADY_SENT') {
                      this.isOTP = false;
                      this.loginErrorMessage = 'RESET_PASSWORD.PASS_RESET_ALREADY_SENT';
                      return;
                    }
                    this.signIn = false;
                    if (this.signIn == false) {
                      this.isMobile = false;
                      this.isOTP = true;
                      this.timeOver = true;
                      this.startTimerForFiveMinute(3);
                    }
                    this.otpText = response.data.otpChar;

                    this.emailId = response.data.emailId;
                    this.loginErrorMessage = null;
                  } else if (response.status.code === 401) {
                    this._toastr.error('', response.status.message);
                    this.count++;
                    if (this.count >= 3) {
                      this.disbleButton = true;
                      this.showCaptcha = true;
                      this.loginForm.controls['captchaToken'].addValidators(
                        Validators.required
                      );
                    }
                  }
                  else if (response.status.code === 400) {
                    this.isLockErrMsg = true;
                    this.loginErrorMessage = response.status.message;
                  }
                  else {
                    this.isLockErrMsg = false;
                    // this._toastr.error('', response.status.message);
                    this.loginErrorMessage = this.message;
                    if (
                      response.status.msgCode ==
                      this.enJsonData[0]['USERNOTFOUND']
                    ) {
                      setTimeout(() => {
                        window.location.href = this.baseUrl;
                      }, 2500);
                    }
                  }
                }
              },
              (error: any) => {
                this.isLoading = false;
                this.disbleButton = false;
                if (this.loginForm.controls['captchaToken'].value) {
                  this.captchaElem.reloadCaptcha();
                  this.loginForm.controls['captchaToken'].setValue(null);
                  this.disbleButton = true;
                  this.loginForm.controls['captchaToken'].addValidators(
                    Validators.required
                  );
                }
                this.count++;
                if (this.count >= 3) {
                  this.showCaptcha = true;
                  this.disbleButton = true;
                  this.loginForm.controls['captchaToken'].addValidators(
                    Validators.required
                  );
                } else {
                  this.showCaptcha = false;
                }
                this.isLockErrMsg = false;
                this.loginErrorMessage = this.message;
              }
            );
        }
      }
    } catch (e) {
      this.isLoading = false;
      // console.log(e);
    }
  }

  // Checking (Matching)  Password and Confirm Password Validation
  onClick(val: string) {
    if (val == 'loginPwd') {
      if (this.password === 'password') {
        this.password = CommonEnums.text;
        this.loginPassword = true;
      } else {
        this.password = CommonEnums.password;
        this.loginPassword = false;
      }
    } else if (val == 'newPwd') {
      if (this.passwordReset === 'password') {
        this.passwordReset = CommonEnums.text;
        this.newPassword = true;
      } else {
        this.passwordReset = CommonEnums.password;
        this.newPassword = false;
      }
    } else if (val == 'confPwd') {
      if (this.passwords === 'password') {
        this.passwords = CommonEnums.text;
        this.confPassword = true;
      } else {
        this.passwords = CommonEnums.password;
        this.confPassword = false;
      }
    }
  }
  loginForgotErrorMessage: any;
  // To get OTP for Forgot Password logic here
  emailOTP() {
    this.isLoading = true;
    this.loginForgotErrorMessage = null;
    this.submitOtpErrorMessage = null;
    this.forgotPasswordErrorMessage = null;
    try {
      (this.forgotPasswordDto.userName =
        this.forgotPwdEmailForm.controls['userName'].value),
        (this.forgotPasswordDto.otpType = CommonEnums.FORGOT_PASSWORD);
      this.sentEmail = this.forgotPwdEmailForm.controls['userName'].value;
      if (this.forgotPwdEmailForm.controls['userName'].value?.length > 8) {
        this.mobileValid = true;
        this.forgotPasswordDto.userName =
          this.forgotPwdEmailForm.controls['userName'].value;
        // "+91" +
        this.forgotPwdEmailForm.controls['userName'].addValidators([
          Validators.minLength(8),
        ]);
      }
      this.forgotPasswordDto.captchaToken =
        this.forgotPwdEmailForm.controls['captchaToken'].value;
      this.forgotPasswordDto.langPref = localStorage.getItem('SocialSelectedLang') || 'ENGLISH';

      if (this.forgotPwdEmailForm.valid || this.mobileValid) {
        this._service
          .postService(
            this._service.API_URL.emailGenerateOtp,
            this.forgotPasswordDto
          )
          .subscribe((response: any) => {
            this.isLoading = false;
            if (response.status.code === 200) {
              if (response.status.msgCode == 'FORGOT_PASSWORD_EMAIL_SENT') {
                this.sentEmail = response.data.emailId;
                this.emailResponse = response.data.otpChar;
                this.isMobile = false;
                this.isOTP = true;
                this.timeOver = true;
                this.startTimerForFiveMinute(3);
                this.forgotPwdEmailForm.reset();
              } else {
                this.loginForgotErrorMessage = null;
                this.emailResponse = response.data;
                this.isMobile = false;
                this.isOTP = true;
                this.timeOver = true;
                this.startTimerForFiveMinute(3);
                this.forgotPwdEmailForm.reset();
              }
            } else {
              this.loginForgotErrorMessage = null;
              this.isOTP = false;
              this.isMobile = true;
              this.forgotPasswordErrorMessage = response.status.message;
              //this._toastr.error('', response.status.message);
              this.isLoading = false;
            }
          });
      }
      this.captchaElem.reloadCaptcha();
      this.forgotPwdEmailForm.controls['captchaToken'].setValue(null);
      this.forgotPwdEmailForm.controls['captchaToken'].addValidators(
        Validators.required
      );
    } catch (e) {
      this.isLoading = false;
    }
  }

  // To get Resend OTP for Forgot Password logic here
  resendOtp() {
    this.forgotPwdEmailForm.controls['captchaToken'].setValue(null);
    this.ngOtpInputRef.setValue(null);
    this.submitOtpErrorMessage = null;
    this.forgotPasswordErrorMessage = null;
    this.loginForgotErrorMessage = null;
    this.isLoading = true;
    try {
      clearInterval(this.timer);
      this.isOTP = true;
      this.timeOver = true;
      this.isMobile = false;
      this.forgotPasswordDto.email = this.sentEmail;
      this.forgotPasswordDto.otpType = CommonEnums.FORGOT_PASSWORD;
      this.forgotPasswordDto.captchaToken = '';
      this._service
        .postService(
          this._service.API_URL.emailGenerateOtp,
          this.forgotPasswordDto
        )
        .subscribe((response: any) => {
          this.isLoading = false;
          if (response.status.code === 200) {
            if (response.status.msgCode == 'FORGOT_PASSWORD_EMAIL_SENT') {
              this.sentEmail = response.data.emailId;
              this.emailResponse = response.data.otpChar;
              this.isMobile = false;
              this.isOTP = true;
              this.forgotPwdEmailForm.reset();
            } else {
              this.emailResponse = response.data;
              this.isMobile = false;
              this.isOTP = true;
              this.timeOver = true;
              this.startTimerForFiveMinute(3);
            }
          } else {
            this.isOTP = true;
            this.timeOver = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (e) {
      this.isLoading = false;
    }
  }
  resendLoginOtp() {
    this.ngOtpInputRef.setValue(null);
    this.submitOtpErrorMessage = null;
    this.forgotPasswordErrorMessage = null;
    this.loginForgotErrorMessage = null;
    let logintype = window.location.href.split('?code=');
    this.loginDto.authorizationCode = logintype[1];
    try {
      this.durationMinutes = '00:00';
      clearInterval(this.timer);
      this.isOTP = false;
      this.timeOver = false;
      this.isMobile = false;
      this._service
        .postService(this._service.API_URL.signIn, this.loginDto)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.otpText = response.data.otpChar;
            this.startTimerForFiveMinute(3);
            this.isMobile = false;
            this.isOTP = true;
            this.timeOver = true;
          } else {
            this.isOTP = false;
            this.timeOver = false;
          }
        });
    } catch (e) { }
  }

  onOtpChange(event: any) {
    this.submitOtpErrorMessage = null;
    this.otpValue = event;
  }


  generateRandomUid(): string {
    return Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
  }

  submitOTP() {
    try {
      if (this.otpValue?.length == 4) {
        this.submitOTPDto.otpChar = this.emailResponse;
        this.submitOTPDto.otpType = CommonEnums.FORGOT_PASSWORD;
        this.submitOTPDto.otpNo = this.otpValue;
        this.submitOTPDto.userName = this.forgotPasswordDto.userName;
        this.randomUid = this.generateRandomUid();
        this.submitOTPDto.randomUid = this.encrypt.encrypt(
          this.randomUid
        );
        this._service
          .postService(
            this._service.API_URL.forgotPasswordOtpVerification,
            this.submitOTPDto
          )
          .subscribe((response) => {
            if (response.status.code === 200) {
              this.otpResponse = response.data;
              this.isOTP = false;
              if (this.encrypt.decrypt(response.data.randomUid) === this.randomUid) {
                this.isReset = true;
              } else {
                $('#forgotpwd').modal('hide');
                this._router.navigateByUrl('/home');
              }
            } else {
              this.submitOtpErrorMessage = response.status.message;
            }
          });
      }
    } catch (e) { }
  }

  //  Reset Password logic is here
  forgotPassword() {
    try {
      this.resendtDto.otpId = this.otpResponse.otpId;
      this.resendtDto.password = this.encrypt.encrypt(
        this.resetPwdForm.controls['password'].value
      );
      this.resendtDto.newPassword = this.encrypt.encrypt(
        this.resetPwdForm.controls['newPassword'].value
      );
      this._service
        .postService(
          this._service.API_URL.publicForgotPassword,
          this.resendtDto
        )
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this._toastr.success('', response.status.message);
            this.isReset = false;
            this.isOTP = false;
            this.isMobile = true;
            this.resetPwdForm.reset();
            this.loginErrorMessage = null;
            this.ngOnInit();
            $('#forgotpwd').modal('hide');
          } else {
            this._toastr.error('', response.status.message);
          }
        });
    } catch (e) { }
  }

  // Login Form Reset
  loginFormReset() {
    this.loginForm.reset();
  }

  closeOEmailCance() {
    $('#forgotpwd').modal('hide');
    this.ngOnInit();
    this.loginErrorMessage = null;
    this.resetPwdForm.reset();
  }
  // Closing Forgot Password Modal (Popup)

  closeResetPassord() {
    this.loginErrorMessage = null;
    this.resetPwdForm.reset();
    this.isOTP = false;
    this.isReset = false;
    this.isMobile = false;
    this.timeOver = false;
    $('#forgotpwd').modal('hide');
    this.ngOnInit();
  }

  onFocusOut() {
    if (
      this.resetPwdForm.controls['password'].value !==
      this.resetPwdForm.controls['newPassword'].value
    ) {
      this.pwdNotMatch = true;
    } else {
      this.pwdNotMatch = false;
    }
  }

  passwordVerify() {
    if (
      this.resetPwdForm.controls['newPassword'].value?.length != 0 &&
      this.resetPwdForm.controls['password'].value !==
      this.resetPwdForm.controls['newPassword'].value
    ) {
      this.pwdNotMatch = true;
    } else {
      this.pwdNotMatch = false;
    }
  }

  // Clicking on Google to Login with the same
  loginWithGoogle() {
    window.location.href = this.getLoginUrl;;
  }

  // Clicking on Google to Login with the same
  loginWithFacebooK() {
    try {
      window.location.href = this.getFaacebookLoginUrl;
    } catch (error) { }
  }

  //  Fetching Social Media Link is here to link to Google and Facebook
  getSocialUrl() {
    this._service
      .getService(this._service.API_URL.getSocialUrl)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.getLoginUrl = response.data.googleUrlLogin;
          this.getFaacebookLoginUrl = response.data.facebookUrlLogin;
          localStorage.setItem('socialData', JSON.stringify(response.data));
        }
      });
  }

  //  To Open the Forgot Password Modal (Popup)
  openForgotPassword() {
    setTimeout(() => {
      this.usernameTempRef.nativeElement.focus();
      document.getElementById('username')?.click();
    }, 1000);
    this.forgotPasswordErrorMessage = null;
    clearInterval(this.timer);
    this.isMobile = true;
    this.isOTP = false;
    this.isReset = false;
    $('#forgotpwd').modal('show');
  }

  //  To Close the Forgot Password Modal (Popup)
  closeForgotPopModal() {
    this.forgotPasswordErrorMessage = null;
    this.loginForgotErrorMessage = null;
    this.submitOtpErrorMessage = null;
    this.forgotPwdEmailForm.reset();
    this.captchaElem.reloadCaptcha();
    this.forgotPwdEmailForm.controls['captchaToken'].setValue(null);
    clearInterval(this.timer);
    $('#forgotpwd').modal('hide');
    this.usernameTempRef.nativeElement.focus();
  }

  //  Start timer for Email Verification, Forgot Password
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;
    const prefix = minute < 10 ? '0' : '';
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  removeSpace(event: any) {
    this.forgotPasswordErrorMessage = null;
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  removePasswordSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }
  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    this.forgotPasswordErrorMessage = null;
    if (event.target.selectionStart === 0) {
      let k;
      k = event.charCode; //         k = event.keyCode;  (Both can be used)
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        k == 43 ||
        (k >= 48 && k <= 57)
      );
    }
  }
  EnterNumber: boolean = false;
  message: string = '';
  keyprss: boolean = true;
  checkInputForForgotEmail(e: any) {
    if (e.code === 'Space') {
      e.preventDefault();
    }
    const key = e.key;
    if (isFinite(key) && this.keyprss) {
      this.EnterNumber = true;
      this.maxLength = 50;
      this.minLength = 8;
      this.emailOrMobileInput = false;
      this.message = this.loginJson[0]['INCORRECTEMAIL'];
      if (this.forgotPwdEmailForm.controls['userName'].value?.length >= 8) {
        this.forgotPwdEmailForm.markAsDirty();
        this.isSubmitted = false;
      }
    } else {
      if (this.forgotPwdEmailForm.controls['userName'].value?.length == 0) {
        this.isSubmitted = false;
      }
      this.message = this.loginJson[0]['INCORRECTEMAIL'];
      this.forgotPwdEmailForm.controls['userName'].addValidators([
        Validators.email,
        Validators.pattern(
          '^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,3}(?:\\.[A-Za-z]{2,3})?)$'
        ),
        RxwebValidators.minLength({ value: 8 }),
      ]);
      this.maxLength = 100;
      this.emailOrMobileInput = true;
    }
  }

  checkInput(e: any) {
    if (e.code === 'Space') {
      e.preventDefault();
    }
    const key = e.key;
    this.message = "LOGIN.INCORRECTEMAILPASS";
    if (isFinite(key) && this.keyprss) {
      this.EnterNumber = true;
      this.maxLength = 50;
      this.minLength = 8;
      this.emailOrMobileInput = false;
      if (this.loginForm.controls['userName'].value?.length >= 8) {
        this.isSubmitted = false;
      }
    } else {
      if (this.loginForm.controls['userName'].value?.length == 0) {
        this.isSubmitted = false;
      }
      this.loginForm.controls['userName'].addValidators([
        Validators.email,
        Validators.pattern(
          '^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,3}(?:\\.[A-Za-z]{2,3})?)$'
        ),
        RxwebValidators.minLength({ value: 8 }),
      ]);
      this.maxLength = 100;
      this.emailOrMobileInput = true;
    }
  }
  // login otp verification
  logIn() {
    try {
      if (this.otpValue.length == 4) {
        this.submitOTPDto.otpChar = this.otpText;
        this.submitOTPDto.otpType = '8';
        this.submitOTPDto.otpNo = this.otpValue;
        this.submitOTPDto.userName = this.loginForm.controls['userName']?.value;
        this._service
          .postService(this._service.API_URL.verifyOTP, this.submitOTPDto)
          .subscribe((response) => {
            if (response && response.status.code === 200) {
              const data = response.data;

              localStorage.setItem('currentUser', JSON.stringify(data.signInResponse));
              localStorage.setItem('jwtToken', data.jwtToken.accessToken);
              localStorage.setItem('accessToken', data.jwtToken.accessToken);
              localStorage.setItem('sessionId', data.signInResponse.sessionId);
              localStorage.setItem('bannerExpiryDate', data.signInResponse.bannerExpiryDate);
              localStorage.setItem('desktopPurchaseNowInternational', data.signInResponse.desktopPurchaseNowInternational);
              localStorage.setItem('DesktopCompatibleVersion', data.signInResponse.desktopCompatibleVer);
              localStorage.setItem('MobileCompatibleVersion', data.signInResponse.mobileCompatibleVer);
              this._router.navigateByUrl('/home');
              this.isOTP = false;
              this.isReset = true;
              this.isOTP = true;
            } else {
              this.submitOtpErrorMessage = response?.status?.message;
            }
          });
      }
    } catch (e) {
    }
  }




  sendMessageToFlutter() {
    if (window && window.parent) {
      window.parent.postMessage({ type: 'messageFromAngular', data: 'Hello from Angular!' }, '*');


      setTimeout(() => {
        if ((window as any).flutter_inappwebview) {
          ((window as any).flutter_inappwebview).callHandler("messageFromAngular", "Hello from Angular!")
            .then((response: any) => console.log("Response from Flutter:", response));
        } else {

        }
      }, 2000);

    } else {
      setTimeout(() => {
        if ((window as any).flutter_inappwebview) {
          ((window as any).flutter_inappwebview).callHandler("messageFromServer", "Hello from Server !")
            .then((response: any) => console.log("Response from Flutter:", response));
        } else {

        }
      }, 2000);

    }
  }
  handleMessageFromFlutter(event: MessageEvent) {
    (window as any).onFlutterMessage = (data: any) => {

      alert("Received from Flutter: " + data);
    };
  }

  isSpanish = false;

  onLanguageSelectionChange(language: string): void {
    this.selectedLanguage = language;
    localStorage.setItem('SocialSelectedLang', this.selectedLanguage);
    const langCode = this._service.getLanguageMap[this.selectedLanguage] || 'en';
    localStorage.setItem('selectedLang', langCode);
    this.translate.use(langCode);
    this.isSpanish = langCode === 'es';
  }
}
